<template>
    <vue-headful :title="'Callback ...'" description="title" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import CategoryService from '../../services/category'
import UserService from '../../services/users'
import DiagnosticoService from '../../services/diagnostic'
import MessageService from '../../services/message'
import AuthService from '../../services/auth'
import SurveyService from '../../services/survey'
import AvatarPackService from '../../services/avatarPack'

import parameters from "../../services/parameters";
import initialReaderValidation from "../../mixins/InitialReaderValidation";

import AnalyticEventsMixin from "../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            avatar: (state) => state.userData.avatarSelected,
            selectedCategories: (state) => state.userData.selectedCategories,
            survey: (state) => state.userData.survey,
            testDiagnostic: (state) => state.dashboard.testDiagnostic,
            loadingState: (state) => state.loading,
            token: (state) => state.token,
            course: (state) => state.userData.user.course,
        }),
    },
    async created() {
        this.$loading(true)
        if ((this.$route.query.token && this.$route.query.token !== '') || !this.token) {
            this.resetState()
            this.resetUserState()
            this.resetDashboardState()
            this.setUserLoaded(false)
            const token = this.getUrlParameter('token')
            this.setToken(token)

            await AuthService.getInfoByToken()
                .then((response) => {
                    this.setUserData(response.content)
                    Sentry.setUser({ id: response.content.userId, username: response.content.username });
                })
                .catch((error) => {
                    console.error(error)
                    window.location.href = process.env.VUE_APP_BEEREADERS_LOGIN_URL
                })
        } else {
            window.location.href = process.env.VUE_APP_BEEREADERS_LOGIN_URL
        }
        Promise.all([
            CategoryService.getMetaDataCategory({ userId: this.user.id }),
            UserService.getUserSummaryInfoByUserId(this.user.id),
            DiagnosticoService.findDiagnosticoPendiente(this.user.id),
            //SurveyService.findSurveyByUser(this.user.id),
            //MessageService.getInboxMessages(this.user.id),
            AvatarPackService.getAvatarPackByName('Default-Pack'),
            parameters.getParameterByName(process.env.VUE_APP_PARAM_FOR_INITIAL_READER)
        ])
            .then((responseArray) => {
                // Categorias
                this.changeCategories(responseArray[0].content)
                // Usuario
                this.setUserData(responseArray[1].content)

                // Diagnosticos pendientes
                this.setPendingDiagnosticData({
                    testDiagnostic: responseArray[2]?.content,
                    userId: this.user.id,
                })
                // Encuesta
                // this.setSurvey(responseArray[3].content)

                // Mensajes
                // this.setRecievedMessages(responseArray[4].content.content)

                this.setDefaultAvatarPack(responseArray[3].content)
                this.setUserLoaded(true)

                this.setInitialReaderActive(responseArray[4].content?.present);

                if (this.validateInitialTour()) {
                    this.initalTour()
                    this.$ga.event('pageLoaded', 'onboarding')
                    this.createAnalyticEvent(AnalyticEventTypes.GoToInitialOnboarding)
                } else {
                    this.notStartTour()
                }

                this.$router.push('/user')
                const userIdentifier = {
                    "name": this.user.firstname,
                    "lastname": this.user.lastname,
                    "dni": this.user.dni,
                    "email": this.user.email,
                    "username": this.user.username,
                    "role": "STUDENT",
                    "school_name": this.user.school.name,
                    "school_id": this.user.school.id,
                    "course_id": this.user.course.id,
                    "course_name": this.user.course.name,
                }
                this.createAnalyticEvent(AnalyticEventTypes.StudentLoggedIn)
                this.$ga.event('pageLoaded', 'login')

                this.setIsMobile(this.isMobileDevice())
            })
            .catch((error) => console.error('Error al obtener la data inicial', error))
            .finally(() => {
                this.$loading(this.loadingState)
            })
    },
    methods: {
        ...mapActions([
            'setToken',
            'resetState',
            'setLoadingState',
            'changeCategories',
            'setLinguisticVariables',
            'setIsMobile'
        ]),
        ...mapActions('common', ['setLinguisticVariables', 'setInitialReaderActive']),
        ...mapActions('userData', [
            'setUserData',
            'setUserLoaded',
            'setSurvey',
            'resetUserState',
            'setRecievedMessages',
        ]),
        ...mapActions('dashboard', [
            'initalTour',
            'setPendingDiagnosticData',
            'notStartTour',
            'setDefaultAvatarPack',
            'resetDashboardState',
        ]),
        getUrlParameter(sParam = '') {
            const sPageURL = window.location.search;
            const sURLVariables = new URLSearchParams(sPageURL);
            return sURLVariables.get(sParam)
        },
        validateInitialTour() {
            if (!this.avatar || !this.selectedCategories.length) return true;

            const isPregrade = ['G0'].some(g => this.grade === g);
            if (!isPregrade && this.testDiagnostic && this.testDiagnostic.length) return true;
            return false;

        },
        isMobileDevice(){
            return (
                RegExp(/Android/i).exec(navigator.userAgent) ||
                RegExp(/webOS/i).exec(navigator.userAgent) ||
                RegExp(/iPhone/i).exec(navigator.userAgent) ||
                RegExp(/iPad/i).exec(navigator.userAgent) ||
                RegExp(/iPad Mini/i).exec(navigator.userAgent)||
                RegExp(/iPod/i).exec(navigator.userAgent) ||
                RegExp(/BlackBerry/i).exec(navigator.userAgent) ||
                RegExp(/Windows Phone/i).exec(navigator.userAgent) ||
                RegExp(/Redmi/i).exec(navigator.userAgent) ||
                RegExp(/XiaoMi/i).exec(navigator.userAgent) ||
                RegExp(/Galaxy/i).exec(navigator.userAgent) ||
                RegExp(/Nexus/i).exec(navigator.userAgent) ||
                RegExp(/Pixel/i).exec(navigator.userAgent) ||
                RegExp(/OnePlus/i).exec(navigator.userAgent) ||
                RegExp(/Huawei/i).exec(navigator.userAgent) ||
                RegExp(/HTC/i).exec(navigator.userAgent)
            )
        }
    },
    mixins: [initialReaderValidation, AnalyticEventsMixin]
}
</script>
